<template>
  <el-main class="page-content-margin-unset">
    <!-- 编辑 -->
    <el-form
      :model="body"
      status-icon
      :rules="rules2"
      label-position="left"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm">
      <el-form-item
        label="身份名称"
        prop="name">
        <el-input v-model.number="body.name"/>
      </el-form-item>
      <el-form-item
        label="管理模块">
        <el-tree
          :data="powerTree"
          show-checkbox
          node-key="uuid"
          ref="tree"
          :props="defaultProps"/>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="event().getCheckedNodes('ruleForm')">保存</el-button>
        <el-button @click="event().onBackClick()">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-main>
</template>

<script>
import qiniu from '../../jslib/qiniu'
import { uploadDomain } from '../../configs/env'
import {
  addGroup, editGroup, getGroupPermissionDetail, getMenuBar,
} from '../../api/system'

export default {
  mixins: [qiniu],
  data() {
    return {
      uploadDomain,
      imglist: [],
      imglist2: [],
      body: {
        uuid: this.$route.query.uuid,
        name: this.$route.query.name || '',
        menu_uuid: [],
      },
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      powerTree: [],
      rules2: {
        name: [
          { required: true, message: '请输入身份名称', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.network().getMenuBar()
    if (this.$route.query.uuid) {
      this.network().getGroupPermissionDetail()
    }
  },
  methods: {
    event() {
      return {
        onBackClick: () => {
          this.$router.go(-1)
        },
        onSureClick: () => {
          this.$refs.ruleForm.validate((valid) => {
            if (valid) {
              // 调接口
              if (this.$route.query.uuid) {
                this.network().editGroup()
                return
              }
              this.network().addGroup()
            } else {
              console.log('error submit!!');
            }
          });
        },
        getCheckedNodes: () => {
          const tree = this.$refs.tree.getCheckedNodes(true)
          this.body.menu_uuid = []
          tree.forEach((item) => {
            this.body.menu_uuid.push(item.uuid)
          })
          this.event().onSureClick()
        },
      }
    },
    network() {
      return {
        getMenuBar: async () => {
          const { status, data } = await getMenuBar()
          if (status !== 200) return
          this.powerTree = data.root
        },
        getGroupPermissionDetail: async () => {
          const { status, data } = await getGroupPermissionDetail({
            group_uuid: this.$route.query.uuid,
          })
          if (status !== 200) return
          this.$refs.tree.setCheckedKeys(data.second_menu_uuid)
        },
        addGroup: async () => {
          const { status } = await addGroup(this.body)
          if (status !== 200) return
          this.$notify({
            title: '新建成功',
            message: '新建身份成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
        editGroup: async () => {
          const { status } = await editGroup(this.body)
          if (status !== 200) return
          this.$notify({
            title: '编辑成功',
            message: '编辑身份成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
      }
    },
    handler() {
      return {
        // 获取详情
        getDetail: () => {
          // 有uuid是编辑
          if (this.$route.query.uuid) {
            this.body = JSON.parse(sessionStorage.getItem('class'))
            this.imglist.push({
              response: {
                hash: this.body.banner_src,
              }, // response里面的hash是必须的
              url: this.imgDomain + this.body.banner_src, // url也是必须的
            })
            this.imglist2.push({
              response: {
                hash: this.body.img_src,
              }, // response里面的hash是必须的
              url: this.imgDomain + this.body.img_src, // url也是必须的
            })
          }
        },
      }
    },
  },
  components: {
  },
};
</script>

<style scoped lang="scss">
.page-content-margin-unset{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/vuepage/system/admin-class-add.vue